/**
 * Copyright 2022-2023 Nordcloud Oy or its affiliates. All Rights Reserved.
 */

// TODO: replace with structuredClone
export const deepClone = <T>(object: T): T => {
  return JSON.parse(JSON.stringify(object)) as T;
};
